import React from "react";
import { checkoutActionTypes, CheckoutItemsProps } from "../../../../../store/modules/checkout/types";
import { Botton, PlusIcon } from "../../styles";
import { useCheckoutFunction } from "../../../../../hooks/useCheckoutFunctions";
import { getQuantityIncrement } from "../../../../../utils/getQuantityIncrement";

interface IProductDetail {
  product: CheckoutItemsProps;
  inputValue: string;
  setInputValue?: (value: string) => {}
}

export function QuantityAddition({ product, inputValue, setInputValue }: IProductDetail) {
  const { handleCheckoutActions } = useCheckoutFunction();
  const isKg = product.product?.un === 'Kg';
  const increment = getQuantityIncrement(product.product);
  return (
    <>
      {product.product && !product.product.services && (
        <Botton
          id="button-action-increment"
          onClick={() => {
            // Incrementa de 100g em 100g
            let baseQty =
              inputValue !== ''
                ? parseFloat(inputValue.replace(',', '.'))
                : Number(product.quantity);
            let newQty;
            if (isKg) {
              newQty = Number((baseQty + increment).toFixed(3));
              // Arredonda para cima para múltiplo de 0.1
              newQty = Math.round(newQty * 10) / 10;
            } else {
              newQty = Math.floor(baseQty + increment);
            }
            const qtyToSend = isKg ? newQty.toFixed(3) : String(newQty);
            // setInputValue(
            //   isKg ? qtyToSend.replace('.', ',') : qtyToSend,
            // );
            handleCheckoutActions(
              checkoutActionTypes.UPDATE_PLU_QTY_CHECKOUT,
              product.product.product_id || '',
              qtyToSend,
              undefined,
              undefined,
            );
          }}
          style={{ background: 'transparent' }}
        >
          <PlusIcon color="green" size={15} />
        </Botton>
      )}
    </>
  )
}